/**
 * Warning shown when a correctly formatted dataset.variable value is not present in the
 * available variables list.
 */
export const CUSTOM_DATASET_VARIABLE_WARNING =
  "This 'dataset.variable' is not in the list of available variables";

/**
 * Maximum allowed length for the dataset and variable parts of a dataset.variable value.
 */
const DATASET_VARIABLE_PART_MAX_LENGTH = 32;

/**
 * Regex used to validate a single dataset.variable value.
 */
export const DATASET_VARIABLE_PATTERN = new RegExp(
  `^([A-Za-z_][A-Za-z0-9_]{0,${DATASET_VARIABLE_PART_MAX_LENGTH - 1}})\\.([A-Za-z_][A-Za-z0-9_]{0,${DATASET_VARIABLE_PART_MAX_LENGTH - 1}})$`,
  "i",
);
